import { useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import SectionHeading from "../../SectionHeading";
import ProjectModal from "../../ProjectModal";
import { pickByTitle } from "../../data/projects";
import { fadeUp, revealOnce, stagger } from "../../motion";
import "../../css/ProjectSection.css";

const FEATURED = pickByTitle([
  "Unified Communications — Teams Direct Routing",
  "Cribxpert",
  "Odoo ERP Deployment",
]);

const ArrowIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path
      d="M8 7a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0V9.414l-8.293 8.293a1 1 0 0 1-1.414-1.414L14.586 8H9a1 1 0 0 1-1-1z"
      fill="currentColor"
    />
  </svg>
);

export const ProjectCard = ({ project, onOpenCase }) => {
  const isCase = Boolean(project.caseStudy);
  const openCase = () => onOpenCase?.(project);

  return (
    <motion.article className="project-card" variants={fadeUp}>
      {isCase ? (
        <button type="button" className="project-card__media" onClick={openCase}>
          <img src={project.img} alt={project.title} loading="lazy" />
        </button>
      ) : (
        <a
          className="project-card__media"
          href={project.href}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={project.img} alt={project.title} loading="lazy" />
        </a>
      )}

      <div className="project-card__body">
        {project.category && (
          <span className="project-card__badge">{project.category}</span>
        )}
        <div className="project-card__tags">
          {project.tags.map((tag) => (
            <span key={tag}>{tag}</span>
          ))}
        </div>
        <h3 className="project-card__title">{project.title}</h3>
        <p className="project-card__text">{project.text}</p>

        {isCase ? (
          <button
            type="button"
            className="project-card__link"
            onClick={openCase}
          >
            Read case study
            <ArrowIcon />
          </button>
        ) : (
          <a
            className="project-card__link"
            href={project.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            View project
            <ArrowIcon />
          </a>
        )}
      </div>
    </motion.article>
  );
};

const ProjectSection = () => {
  const [activeProject, setActiveProject] = useState(null);

  return (
    <section className="section featured-projects">
      <div className="container">
        <SectionHeading eyebrow="Projects" title="Featured work" />

        <motion.div
          className="project-grid"
          variants={stagger}
          {...revealOnce}
        >
          {FEATURED.map((project) => (
            <ProjectCard
              key={project.title}
              project={project}
              onOpenCase={setActiveProject}
            />
          ))}
        </motion.div>

        <div className="featured-projects__cta">
          <Link to="/Projects" className="btn btn-ghost">
            View all projects →
          </Link>
        </div>
      </div>

      <AnimatePresence>
        {activeProject && (
          <ProjectModal
            project={activeProject}
            onClose={() => setActiveProject(null)}
          />
        )}
      </AnimatePresence>
    </section>
  );
};

export default ProjectSection;
